<main class="main-home-secton">
  <div class="infra-dev2">
    <img
      class="banner-img"
      src="/assets/images/resource-bg-banner.png"
      alt=""
    />
    <div class="container">
      <div class="text-center">
        <h2 class="title">Resources</h2>
      </div>
    </div>
  </div>
  <div class="infra-dev">
    <div class="container">
      <div class="text-center">
        <h2 style="margin: 5%; color: #05032f; font-weight: bold">
          Schemes implemented through Incubators
        </h2>
      </div>
      <div class="row">
        <div
          class="col-lg-4 col-md-6 col-sm-12 map-bg"
          *ngFor="let item of resourceData"
        >
          <div class="card infra_data_div new-card-respon">
            <div class="text-center">
              <img
                [src]="item.imgSrc"
                alt="Smiling person"
                class="infra_img"
                alt=""
              />
              <mat-divider></mat-divider>
            </div>
            <div>
              <p class="quote mb-0">{{ item.description }}</p>
              <div class="docu_div">
                <button
                  class="btn btn-warning docu_btn"
                  (click)="linkclick(item.link)"
                >
                  Know More
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container py-3">
    <div class="container">
      <div class="text-center">
        <h2 style="margin: 5%; color: #05032f; font-weight: bold">
          Newsletters by Incubators
        </h2>
      </div>

      <div class="row" *ngIf="newsLetterList">
        <div
          class="col-lg-4 col-md-6 col-sm-12"
          *ngFor="let list of newsLetterList; let i = index"
        >
          <div class="card newsletter_dev">
            <div class="logo-image text-center">
              <img [src]="list.incubatorLogoFile" alt="" />
            </div>
            <div style="padding: 20px">
              <h5 class="newsheading">{{ list.title }}</h5>
              <div class="d-flex">
                <span
                  ><span style="font-size: 12px; color: gray; margin-left: 3px"
                    >Posted : </span
                  >{{ list.newsletterDate }}</span
                >
                <span class="ml-auto"
                  ><a
                    [href]="list.newsletterName"
                    target="_blank"
                    style="color: orange"
                    (click)="viewmore()"
                    >View more</a
                  ></span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="text-center" *ngIf="newsLetterList.length == 0">
      <div class="no-data-div image-align">
        <img
          src="assets/images/startupTn-new-logo.png"
          class="img-fluid new-log-image"
          alt=""
        />
        <h6>Coming soon</h6>
      </div>
    </div>

    <div class="newsmore-btn">
      <button class="btn btn-warning" (click)="newsletterdetails()">
        <a>More Newsletters</a>
      </button>
    </div>
  </div>
</main>
<app-footer></app-footer>
